module.exports = __webpack_public_path__ + "static/media/consultation_05.661ecb52.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_05.png
// module id = 578
// module chunks = 0